import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=e938abcc&scoped=true&"
import script from "./Contribution.vue?vue&type=script&lang=js&"
export * from "./Contribution.vue?vue&type=script&lang=js&"
import style0 from "./Contribution.vue?vue&type=style&index=0&id=e938abcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e938abcc",
  null
  
)

export default component.exports